// removed by extract-text-webpack-plugin
module.exports = {"seo":"seo___2Ktk2","container":"container___2zAT8","column":"column___1Nb1N","wrapper":"wrapper___syBEF","column-title":"column-title___1L7rd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/Seo/Seo.scss
// module id = CIJv
// module chunks = 60